import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngxs/store';
import { LoadRimsPhaseInfos } from '../states/rims/rims.actions';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RimsPhaseInfosResolver implements Resolve<boolean> {
  constructor(private store: Store) {}

  async resolve(): Promise<boolean> {
    await firstValueFrom(this.store.dispatch(new LoadRimsPhaseInfos()));
    return true;
  }
}
